module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "block-small-media live-video-container"
  }, [(_vm.isCanceled) ? _c('div', {
    staticClass: "live-video-meta rec active"
  }, [_vm._v(_vm._s(_vm.textCanceled))]) : _c('div', {
    staticClass: "live-video-ended"
  }, [_c('span', [_vm._v(_vm._s(_vm.videoTempText))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.item.fallback,
      "alt": _vm.item.altText,
      "title": _vm.item.altText
    }
  })]), _vm._v(" "), _c('slider-item-information', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da328eb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider/SliderItem.vue
// module id = 106
// module chunks = 1